/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'star': {
    width: 20,
    height: 19,
    viewBox: '0 0 20 19',
    data: '<path pid="0" d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" _fill="#FDBC3C" fill-rule="evenodd"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/star.js